<template>
  <div>
    <dashboard-header :text="$t('ui.sosCaseDetail')" :on-back="goBack"/>

    <div class="d-flex align-content-center justify-content-center">
      <v-card
          elevation="0"
          :loading="loading"
          class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail
              data-colon
              :items="items"
              :headers="tableHeaders"
          />
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import {API2} from "../../api";
import {SOS_TYPE} from "../../config/constant";
import i18n from "../../lang/i18n";
import DataDetail from "../base/DataDetail.vue";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null,
    };
  },
  computed: {
    header() {
      return this.item ? this.item.sosType : ''
    },
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.title'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.content')}
      ]
    },
    items() {
      return [
        {
          title: i18n.t("sosCase.source"),
          data: this.detail ? this.detail.sourceInfo.name : ''
        },
        {
          title: i18n.t("sosCase.targets"),
          data: this.detail ? this.getTargets() : ''
        },
        {
          title: i18n.t("sosCase.sosType"),
          data: this.detail ? this.detail.sosTypeInfo.name : ''
        },
        {
          title: i18n.t("sosCase.sosMessage"),
          data: this.detail ? this.detail.description : ''
        },
        {
          title: i18n.t("base.createdAt"),
          data: this.detail ? this.formatDate(this.detail.createdAt) : ''
        },
        {
          title: i18n.t("base.updatedAt"),
          data: this.detail ? this.formatDate(this.detail.updatedAt) : ''
        }
      ];
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      this.detail = await this.get(API2.SOS_CASE, {path: item.sosCaseId})
      if (!this.detail) {
        // No data found, go back to list
        this.goBack();
      }
    },
    goBack() {
      this.openTab(0)
    },
    listTargets() {
      if (!this.detail) {
        return [];
      }
      if (
          this.detail.sosTypeInfo.sosTypeId === SOS_TYPE.OUT_THE_HOSPITAL
      ) {
        return this.detail.targetsInfo.map(_department => {
          return {
            ..._department,
            name: `${i18n.t("sosCase.hospital")}: ${
                _department.Hospital.name
            }`
          };
        });
      }
      return this.detail.targetsInfo;
    },
    checkOutOfHospital() {
      if (
          this.detail &&
          this.detail.sosTypeInfo &&
          this.detail.sosTypeInfo.sosTypeId === SOS_TYPE.OUT_THE_HOSPITAL
      ) {
        return true;
      }
      return false;
    },
    getTargets() {
      if (!this.detail) {
        return [];
      }
      let list = [];
      if (
          this.detail.sosTypeInfo.sosTypeId === SOS_TYPE.OUT_THE_HOSPITAL
      ) {
        list = this.detail.targetsInfo.map(_department => {
          return {
            ..._department,
            name: `${i18n.t("sosCase.hospital")}: ${
                _department.Hospital.name
            }`
          };
        });
      } else {
        list = this.detail.targetsInfo;
      }
      const result = list.map(value => {
        if (this.checkOutOfHospital()) {
          return {
            title: "",
            data: `${value.name} - ${
                value.confirmInfo &&
                value.confirmInfo.confirmed === 1
                    ? i18n.t("base.confirmed")
                    : i18n.t("base.unconfimred")
            }`
          };
        } else {
          return {
            title: "",
            data: value.name
          };
        }
      });
      return result;
    }
  },
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
